export const COLOR_MAP = {
  color1: '#17a8d8',
  color2: '#6184f4',
  color3: '#048abf',
};

export type TColors = keyof typeof COLOR_MAP;